import React from 'react';
import ImageFallback from '@components/common/Image/ImageFallback';
import { marketingEmailSignupId } from '@constants/marketing';
import { getCdnImageUrl } from '@utils/cloudflare';
import useIsMobile from '@hooks/useIsMobile';
import withPromoLogic, { PromoLogicProps } from './withPromoLogic';

const promoConfig = {
  original: 'Unlock exclusive savings and access to new hotels',
  sale: 'Our Spring Break Sale is live. Get $50 off.',
};

function CaptureEmailDLPInLine({ handleClick }: PromoLogicProps) {
  const isMobile = useIsMobile();

  return (
    <div className="border-b-8 border-rp-gray-divider py-6 px-4 d:py-7 d:px-0">
      <button
        type="button"
        onClick={handleClick}
        className={`flex flex-col relative w-full ${marketingEmailSignupId}`}
        style={{ height: '237px' }}
      >
        <ImageFallback
          src={getCdnImageUrl(
            686,
            isMobile
              ? 'web_marketing_dlp_inline_mobile.png'
              : 'web_marketing_dlp_inline_desktop.png',
            'https://static-assets.resortpass.com/assets/',
          )}
          layout="fill"
          alt={promoConfig.original}
        />

        <div className="-tracking-0.25 absolute font-rp-basetica text-25 text-left text-rp-inverted mr-6 leading-125% top-12 left-26px d:text-29 d:-tracking-0.29 d:mr-0 d:max-w-360">
          {promoConfig.original}
        </div>

        <div className="absolute flex items-center justify-center bg-rp-inverted text-rp-primary-black-medium font-rp-pn-semi-bold text-base -tracking-0.2 rounded-md h-10 w-116px left-26px bottom-54px">
          Save Now
        </div>
      </button>
    </div>
  );
}

export default withPromoLogic(CaptureEmailDLPInLine, 'CaptureEmailDLPInLine');
